/*
 * @Author: your name
 * @Date: 2021-12-30 10:57:51
 * @LastEditTime: 2021-12-31 10:50:37
 * @LastEditors: Please set LastEditors
 * @Description: 定位
 * @FilePath: \smart-community\src\views\map\SatelliteMap\js\location.js
 */
import handleCoordinates from "./handleCoordinates";

const { setPoint } = handleCoordinates();
class Location {
  fly = (view, location, defineZoom = null, done) => {
    location = setPoint(location);
    const duration = 2000;
    let zoom;
    if (defineZoom == null) {
      zoom = view.getZoom();
    } else {
      zoom = defineZoom
    }
    console.log(zoom);
    let parts = 2;
    let called = false;

    function callback(complete) {
      --parts;
      if (called) {
        return;
      }
      if (parts === 0 || !complete) {
        called = true;
        done && done(complete);
      }
    }
    view.animate({
        center: location,
        duration: duration
      },
      callback
    );
    view.animate({
        zoom: zoom - 1,
        duration: duration / 2
      }, {
        zoom: zoom,
        duration: duration / 2
      },
      callback
    );
  };
}
export default Location;